<!--
 * @Author: your name
 * @Date: 2020-08-13 16:50:39
 * @LastEditTime: 2021-01-19 11:31:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/payment/component/EachPayment/index.vue
-->
<style scoped lang="sass">
.choosed
  color: var(--menu-primary-background-colour) !important

.each_payment
  display: flex
  align-items: center
  padding: 0 17PX
  border-bottom: 1PX solid #f1f2f3

  .img_box
    height: 36PX
    width: 55PX
    margin-right: 17PX
    background: #fff
    border-radius: 5PX

    .img
      height: 100%
      width: 100%

  .pay
    line-height: 58PX
    height: 58PX
    font-size: 14PX
    color: var(--menu-primary-text-colour)
.additional_container
    width: 100%

</style>

<template lang="pug">
.each_payment_container()
  div
    slot(name="button")
    slot(name="title")
  .each_payment(@click="emit")
    .img_box
      img(:src="src").img
    .pay(:class="{'choosed': choosed}" v-html="name" )
  //- Always rendered (not v-show) so a gateway hosted-field iframe mounted here loads in the
  //- background at init; revealed instantly when this row is chosen. Off-screen+hidden when not
  //- chosen (gateway-field--armed) instead of display:none, which would break iframe load.
  .additional_container(:id="'card-payment-'+id" :class="{ 'gateway-field--armed': !choosed }" )
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    src: {
      type: String
    },
    name: {
      type: String
    },
    choosed: {
      type: Boolean
    },
    id: {
      type: String,
      default: ''
    }
  }
})

class EachPayment extends Vue {
  emit() {
    this.$emit('clickItem')
  }
}

export default EachPayment
</script>
